// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.btn-primary-normal[data-v-5ec83d69] {\n  padding-top: 0.68rem;\n  padding-bottom: 0.68rem;\n}\n.search-input-base[data-v-5ec83d69] {\n  min-width: 250px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
